import React from "react";
import MDBox from "components/MDBox";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

function WelcomeMessage({ userName }) {
    return (
        <MDBox mb={3} textAlign="center">
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#344767", mb: 0.5 }}>
                Welcome to Comparedly, {userName}! 👋
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", fontSize: "0.82rem" }}>
                Please create a workspace to get started. You can then add members to your workspace.
            </Typography>
        </MDBox>
    );
}

WelcomeMessage.propTypes = {
    userName: PropTypes.string,
};

export default WelcomeMessage;
